
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.873 36.546v-12.8c0-6.7-.1-14.9-8.4-16.5-7.4-1.5-11 4.1-12 10.2-.3.5-.3 1.3-.2 1.9 0 .5-.1 1.1-.1 1.6v12.4c0 1.9-.5 4.7.2 6.6 1.1 2.8 4.8 1.8 7.3 1.8h.2v5.8c0 1.9-.2 5.4 2.6 5.4 2.9-.4 2.6-3.4 2.6-5.6v-5.6h5.7c.1 0 .2 0 .2-.1 2.2-.8 1.9-3.1 1.9-5.1zm-18.6 2.1c-1-.5-.5-.1-.7-1.8-.2-1.7 0-3.6 0-5.3 0-3.6-.1-7.3 0-10.9 3.6 1.8 7.1 3.6 10.7 5.4.9.5 1.2-2.6.4-3-3.6-1.8-7.1-3.6-10.7-5.4 2.4-10.3 17.3-9.3 17.6 2.7v6.1l-2.4-1.2c-.9-.5-1.2 2.6-.4 3 .9.5 1.9.9 2.8 1.4v6.6c0 .5.2 1.5 0 1.9-.1.2-.1.3-.1.3-.1 0-.3 0-.6.1h-10.4c-.1 0-.2.1-.3.2-2 .3-4.5.5-5.9-.1zm8.3 11.2c-2.1 0-1.3-3.2-1.3-4.6v-3.5h2.5v6.5c0 1.2.1 1.4-1.2 1.6z"}})])
          )
        }
      }
    